import { useQuery } from '@tanstack/react-query';
import type { DashboardStats } from '../types/dashboard';
import { getAccessToken } from '../lib/supabase';

async function fetchDashboardStats(): Promise<DashboardStats> {
  const token = await getAccessToken();

  if (!token) {
    throw new Error('Not authenticated');
  }

  const response = await fetch('/api/dashboard/stats', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch dashboard statistics');
  }

  return response.json();
}

export function useDashboardStats() {
  return useQuery<DashboardStats>({
    queryKey: ['dashboard-stats'],
    queryFn: fetchDashboardStats,
    staleTime: 1000 * 60, // 1 minute
    refetchInterval: 1000 * 60, // Auto-refresh every 1 minute
    refetchOnWindowFocus: true,
    retry: 2
  });
}
